import { GroupEntityService } from 'src/app/services/group-entity.service';
import { CustomerProfileService } from './../../../services/customer-profile.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SocietiesService, Society, User, UserService } from '@pwc-bei/common';
import { PwcIconsLibrary } from '@pwc-bei/icons';
import {
  AuthenticationService,
  Authority,
  AuthorizationService,
} from '@pwc-bei/security';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { environment } from '../../../../../environments/environment';
import { EAccessPlanVariable } from '../../../../enum/access-plan-variable';
import { RoutePath } from '../../../../enums/route-path.enum';
import { AuthorityCodeEnum } from '../../../../enums/security/authority-code.enum';
import { SocietySelectionUtils } from '../../../../utils/society-selection-utils';
import { BasePage } from '../../../base-page/base-page';
import { first } from 'rxjs/operators';
import { UserProfile } from 'src/app/pages/user-profile/models/user-profile';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-bazar',
    templateUrl: './bazar.component.html',
    styleUrls: ['./bazar.component.scss'],
    standalone: false
})
export class BazarComponent extends BasePage implements OnInit {
  user: User;
  esgEnabled = environment.esgEnabled;
  vcfEnabled = environment.vcfEnabled;
  aiEnabled = environment.aiEnabled;
  columnSize = '';

  directChannelLimited: boolean = true;
  public AuthorityCodeEnum = AuthorityCodeEnum;

  disabledForRoles = ['ACCESSO_B2C_OPERATORE_BANCARIO', 'ACCESSO_DIREZIONE_GENERALE']

  public canaleDiretto: Boolean = false;

  constructor(
    private iconsLibrary: PwcIconsLibrary,
    private authenticationService: AuthenticationService,
    private router: Router,
    private societyService: SocietiesService,
    private userService: UserService,
    private authorizationService: AuthorizationService,
    public authenticationUtilsService: AuthenticationUtilsService,
    private customerProfileService: CustomerProfileService,
    private groupEntityService: GroupEntityService,
    private cookieService: CookieService,
  ) {
    super();
    this.canaleDiretto = environment.directChannel;
  }

  ngOnInit(): void {
    super.ngOnInit();
    const selectedSociety = sessionStorage.getItem('society');
    super.ngOnInit();

    this.cookieService.delete("JSESSIONID");

    this.setDirectChannelLimited();
    if (this.esgEnabled && this.vcfEnabled) {
      this.columnSize = 'col-lg-3 col-md-6 col-xs-12 py-2 my-2';
    }
    // DA VEDERE COSA SI PREFERISCE!
    // else if (!this.esgEnabled && !this.vcfEnabled){
    //   this.columnSize ='col-lg-6 col-md-6 col-xs-12 py-2 my-2';
    // }
    else {
      this.columnSize = 'col-lg-4 col-md-6 col-xs-12 py-2 my-2';
    }
    if (selectedSociety === null || selectedSociety === undefined) {
      this.societyService.currentSociety$.subscribe((society) => {
        if (society == null) {
          this.userService
            .getSocietiesForGroupCodes(SocietySelectionUtils.GROUP_CODES)
            .subscribe((societies: Society[]) => {
              if (societies.length > 1) {
                const selectedSocietyId = sessionStorage.getItem('societyId')
                  ? parseInt(sessionStorage.getItem('societyId'), 10)
                  : null;
                if (selectedSocietyId != null) {
                  console.log('selectedSocietyId ', selectedSocietyId);
                  const index = societies.findIndex(
                    (s) => s.id == selectedSocietyId,
                  );
                  this.societyService.setSociety(societies[index]);
                  sessionStorage.removeItem('societyId');
                } else {
                  console.log('selectedSocietyId ', selectedSocietyId);
                  this.router.navigate([RoutePath.SOCIETY_SELECTION]);
                }
              } else {
                if (societies.length > 0) {
                  this.societyService.setSociety(
                    societies[societies.length - 1],
                  );
                }
              }
            });
        }
      });
    } else {
      this.societyService.setSociety(JSON.parse(selectedSociety));
    }

    this.initUserPlan();
  }

  isUserPlus: boolean = false;
  isUserSmart: boolean = false;

  initUserPlan(): void {
    if (environment.accessPlanEnabled) {
      this.authorizationService
        .getAuthorities()
        .subscribe((auths: Authority[]) => {
          var authorities: String[] = auths.map(a => a.code);
          this.isUserSmart = authorities.filter(a => a.localeCompare('ROLE_BANDI_B2C_SMART') == 0).length > 0;
          this.isUserPlus = authorities.filter(a => a.localeCompare('ROLE_BANDI_B2C_PLUS') == 0).length > 0;
          var isUserPremium = !(this.isUserPlus || this.isUserSmart);
          this.authenticationUtilsService.setSessionVariable(EAccessPlanVariable.IS_USER_SMART, this.isUserSmart);
          this.authenticationUtilsService.setSessionVariable(EAccessPlanVariable.IS_USER_PLUS, this.isUserPlus);
          this.authenticationUtilsService.setSessionVariable(EAccessPlanVariable.IS_USER_PREMIUM, isUserPremium);
        });
    } else {
      this.authenticationUtilsService.setSessionVariable(
        EAccessPlanVariable.IS_USER_PREMIUM,
        true,
      );
    }
  }

  setDirectChannelLimited() {
    this.customerProfileService.getMyProfile()
      .pipe(first())
      .subscribe((profile: UserProfile) => {
        // CHECK AUTHORITIES
        this.groupEntityService.findByUserId(profile.userId, null).subscribe(groupEntityList=>{
          let disable = false;
          groupEntityList.forEach(groupEntity=>{
            if(this.disabledForRoles.includes(groupEntity.groupCode)){
              disable = true
            }
          })
          if(disable) {
            //this.ngxLoader.stop();
            this.directChannelLimited = true;
          } else {
            this.directChannelLimited = false
          }
        })
      })
  }

  getUser(user: User) {
    this.user = user;
  }

  goToCalls() {
    this.router.navigate([RoutePath.BANDI]);
  }

  goToIncentives() {
    this.router.navigate([RoutePath.INCENTIVI]);
  }

}
